// AUTO-GENEROWANE przy starcie/buildzie (scripts/gen-build-info.js). Nie edytuj ręcznie.
export const BUILD_INFO = {"version":"1.9.26","builtAt":"2026-11-04T22:27:02.257Z"};
